export default __webpack_public_path__ + "static/media/strikethrough.512bac5f.svg";